import { createSvgIcon } from '@mui/material/utils';

const Menu = createSvgIcon(
    <svg viewBox="0 -960 960 960">
        <path d="M120-240v-80h720v80H120Zm0-200v-80h720v80H120Zm0-200v-80h720v80H120Z" />
    </svg>,
    'Menu'
);

export { Menu };
